import * as React from "react";
const SvgClosedChevron = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 8, viewBox: "0 0 10 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.53333 8L9.06667 0H0L4.53333 8Z", fill: "currentColor" }));
export default SvgClosedChevron;
